
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type manufacturersContainerRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function manufacturersContainerRT(): TemplateResult<manufacturersContainerRTRootProps> {
    function repeatHierarchicalGroups1(hierarchicalGroups, hierarchicalGroupsIndex) {
        return [hierarchicalGroups(function () {
                return this.imageUrl ? _createElement('div', {
                    'className': 'cm_vehicle-categories_category-wrapper',
                    'key': '5'
                }, [_createElement('div', {
                        'className': 'cm_vehicle-categories_category-container',
                        'key': '870'
                    }, _createElement('a', {
                        'href': this.href,
                        'className': 'cm_vehicle-categories_link'
                    }, _createElement('div', { 'className': 'cm_vehicle-categories_category-image-container' }, this.imageUrl ? _createElement('img', {
                        'alt': window.Convermax.removeSpecialCharacters(this.value),
                        'title': window.Convermax.removeSpecialCharacters(this.value),
                        'className': 'cm_vehicle-categories_category-image',
                        'src': this.getImageOrDefault(this.imageUrl),
                        'key': '285'
                    }) : null, !this.imageUrl ? _createElement('span', {
                        'className': 'cm_vehicle-categories_category-image-text',
                        'key': '535'
                    }, this.value) : null), _createElement('div', { 'className': 'cm_vehicle-categories_category-title-container' }, this.hasSubvalues ? [_createElement('h3', {
                            'className': 'cm_vehicle-categories_category-title',
                            'key': '7161'
                        }, this.value)] : null, !this.hasSubvalues ? [_createElement('h2', {
                            'className': 'cm_vehicle-categories_category-title',
                            'key': '8561'
                        }, this.value)] : null, _createElement('svg', {
                        'className': 'icon chevron',
                        'title': 'icon chevron right'
                    }, _createElement('path', { 'd': 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })))))]) : null;
            }, { count: undefined })];
    }
    return _createElement('div', { 'className': 'cm_vehicle-categories cm_vehicle-categories__manufacturers cm_vehicle-categories__flat' }, _createElement.apply(this, [
        'div',
        { 'className': 'cm_vehicle-categories_category-wrapper-repeater  cmRepeater_hierarchicalGroups' },
        _map(this.hierarchicalGroups, repeatHierarchicalGroups1.bind(this))
    ]));
}
        export const componentNames = []